<template>
    <div>
        <div class="">
            <!-- <v-chip-group :items="serp_types">


        </v-chip-group> -->
            <v-row>
                <v-col :cols="selectedType === 'popular_products' && this.seller.length > 0 ? 6 : 12">
                    <v-select @change="fetchFrequency()" color="primary" rounded filled :items="serp_types" v-model="selectedType">
                        <template v-slot:item="{ item }">
                            <v-icon v-if="getValidSerpType(item)" class="mr-2" size="16px">${{ getValidSerpType(item) }} </v-icon>
                            <v-icon v-else class="mr-2" size="16px">{{ presetIcons[item] ? presetIcons[item] : "mdi-application-outline" }}</v-icon>
                            <span style="text-transform: capitalize">{{ item.replace(/_/g, " ") }}</span>
                        </template>
                        <template v-slot:selection="{ item }">
                            <div class="d-flex align-center">
                                <v-icon v-if="getValidSerpType(item)" class="mr-2" size="16px">${{ getValidSerpType(item) }} </v-icon>
                                <v-icon v-else class="mr-2" size="16px">{{ presetIcons[item] ? presetIcons[item] : "mdi-application-outline" }} </v-icon>
                                <span style="margin-left: 8px; text-transform: capitalize">{{ item.replace(/_/g, " ") }}</span>
                            </div>
                        </template>
                    </v-select>
                </v-col>
                <v-col v-if="selectedType === 'popular_products' && this.seller.length > 0" cols="6">
                    <v-select
                        @change="fetchSellerHistory()"
                        chips
                        small-chips
                        deletable-chips
                        multiple
                        v-if="selectedType === 'popular_products'"
                        v-model="selectedSeller"
                        :items="seller"
                        color="primary"
                        rounded
                        mandatory
                        filled
                        return-object
                        item-text="seller"></v-select
                ></v-col>
            </v-row>
        </div>
        <line-chart v-if="selectedType === 'popular_products' && this.seller.length > 0" :dataChart="ppchartData" :countGraph2="renderChart" :options="graphOptionspp"></line-chart>

        <bar-chart v-else :dataChart="chartData" :countGraph2="renderChart" :options="graphOptions"></bar-chart>
    </div>
</template>

<script>
    import monitoringTaxonomy from "@/mixins/monitoringTaxonomy"
    import LineChart from "../charts/LineChart"
    import BarChart from "../charts/BarChart"
    import { computed } from "vue"
    var sellerHistoryData = []
    export default {
        mixins: [monitoringTaxonomy],
        components: {
            BarChart,
            LineChart
        },
        props: {
            show: Boolean,
            category_id: String,
            show_ai: Boolean,
            selectedDates: Array
        },
        data() {
            return {
                selectedSeller: [],
                selectedType: "ai_overview",
                serp_types: [],
                title: "Frequency",
                subtitle: "test",
                presetIcons: {
                    ai_overview: "mdi-head-snowflake-outline"
                },
                validSerpTypes: [
                    "people_also_search",
                    "knowledge_graph",
                    "jobs",
                    "twitter",
                    "commercial_units",
                    "stocks_box",
                    "questions_and_answers",
                    "podcasts",
                    "scholarly_articles",
                    "top_sights",
                    "visual_stories",
                    "map",
                    "hotels_pack",
                    "mention_carousel",
                    "events",
                    "top_stories",
                    "recipes",
                    "local_services",
                    "featured_snippet",
                    "google_flights",
                    "google_posts",
                    "google_reviews",
                    "popular_products",
                    "multi_carousel",
                    "find_results_on",
                    "carousel",
                    "local_pack",
                    "people_also_ask",
                    "related_searches",
                    "rich_snippet",
                    "organic",
                    "paid",
                    "images",
                    "shopping",
                    "video",
                    "answer_box",
                    "magnify",
                    "database",
                    "logout",
                    "bell",
                    "short_videos"
                ],
                testFrequencyData: [
                    { date: "2025-03-01T00:00:00.000Z", count: 20, total_count: 40, keyword_count: 78 },
                    { date: "2025-03-02T00:00:00.000Z", count: 18, total_count: 35, keyword_count: 78 },
                    { date: "2025-03-03T00:00:00.000Z", count: 22, total_count: 38, keyword_count: 78 },
                    { date: "2025-03-04T00:00:00.000Z", count: 17, total_count: 34, keyword_count: 78 },
                    { date: "2025-03-05T00:00:00.000Z", count: 19, total_count: 33, keyword_count: 78 },
                    { date: "2025-03-06T00:00:00.000Z", count: 15, total_count: 30, keyword_count: 78 },
                    { date: "2025-03-07T00:00:00.000Z", count: 14, total_count: 28, keyword_count: 78 },
                    { date: "2025-03-08T00:00:00.000Z", count: 13, total_count: 26, keyword_count: 78 },
                    { date: "2025-03-09T00:00:00.000Z", count: 12, total_count: 24, keyword_count: 78 },
                    { date: "2025-03-10T00:00:00.000Z", count: 10, total_count: 20, keyword_count: 78 },
                    { date: "2025-03-11T00:00:00.000Z", count: 9, total_count: 18, keyword_count: 78 },
                    { date: "2025-03-12T00:00:00.000Z", count: 8, total_count: 16, keyword_count: 78 }
                ],
                seller: [],
                renderChart: 0,
                serpType: {},
                chartData: {
                    labels: [],
                    datasets: []
                },
                ppchartData: {
                    labels: [],
                    datasets: []
                },
                graphOptions: {
                    tooltips: {
                        // callbacks: {
                        //     label: function (tooltipItems, data) {
                        //         const dataset = data.datasets[tooltipItems.datasetIndex]
                        //         const originalValue =
                        //             tooltipItems.datasetIndex === 1
                        //                 ? data.datasets[0].data[tooltipItems.index] + tooltipItems.yLabel // Summe berechnen
                        //                 : tooltipItems.yLabel
                        //         return dataset.label + ": " + originalValue.toLocaleString()
                        //     }
                        // }
                    },
                    legend: {
                        display: true,
                        labels: {
                            fontSize: 14
                        }
                    },
                    plugins: {
                        legend: {
                            labels: {
                                usePointStyle: true,
                                pointStyle: "rectRounded"
                            }
                        }
                    },
                    scales: {
                        yAxes: [
                            {
                                stacked: true,
                                scaleLabel: {
                                    display: true,
                                    labelString: "SERP Item Count"
                                },
                                ticks: {
                                    beginAtZero: true,
                                    callback: function (value, index, values) {
                                        return value.toLocaleString()
                                    }
                                }
                            }
                        ],
                        xAxes: [
                            {
                                stacked: true,
                                scaleLabel: {
                                    display: true,
                                    labelString: "Dates"
                                }
                            }
                        ]
                    },
                    responsive: true,
                    maintainAspectRatio: false
                },
                graphOptionspp: {
                    tooltips: {
                        // callbacks: {
                        //     label: function (tooltipItems, data) {
                        //         const dataset = data.datasets[tooltipItems.datasetIndex]
                        //         const originalValue =
                        //             tooltipItems.datasetIndex === 1
                        //                 ? data.datasets[0].data[tooltipItems.index] + tooltipItems.yLabel // Summe berechnen
                        //                 : tooltipItems.yLabel
                        //         return dataset.label + ": " + originalValue.toLocaleString()
                        //     }
                        // }
                    },
                    legend: {
                        display: true,
                        labels: {
                            fontSize: 14
                        }
                    },
                    plugins: {
                        legend: {
                            labels: {
                                usePointStyle: true,
                                pointStyle: "rectRounded"
                            }
                        }
                    },
                    scales: {
                        yAxes: [
                            {
                                scaleLabel: {
                                    display: true,
                                    labelString: "SERP Item Count"
                                },
                                ticks: {
                                    beginAtZero: true,
                                    callback: function (value, index, values) {
                                        return value.toLocaleString()
                                    }
                                }
                            }
                        ],
                        xAxes: [
                            {
                                stacked: true,
                                scaleLabel: {
                                    display: true,
                                    labelString: "Dates"
                                }
                            }
                        ]
                    },
                    responsive: true,
                    maintainAspectRatio: false
                }
            }
        },
        computed: {
            isOBI() {
                return window.location.href.includes("apollon.obi.com")
            }
        },
        methods: {
            async fetchSellers() {
                const url =
                    (JSON.parse(process.env.VUE_APP_MONITORING_PROXY_COMPANY_IDS).indexOf(
                        this.CryptoJS.AES.decrypt(localStorage.company_id, process.env.VUE_APP_ENCRYPTION_PW).toString(this.CryptoJS.enc.Utf8)
                    ) == -1
                        ? process.env.VUE_APP_MONITORING_API_URL
                        : process.env.VUE_APP_APIURL + "/monitoring-api") + "/project/get/sellers"
                let post_data = {
                    company_id: localStorage.company_id,
                    project_id: this.$route.params.id,
                    serp_type: "popular_products",
                    category_id: this.category_id,
                    importDate: this.selectedDates[1] ? this.selectedDates[1] : this.selectedDates[0]
                }
                let response_data = await this.$helpers.axiosPost(url, this.withTaxonomy(post_data))
                console.log(response_data)
                if (response_data.data.length > 0) {
                    this.seller = response_data.data.filter((d) => d.seller)
                    this.selectedSeller = this.seller.slice(0, 4)
                    this.fetchSellerHistory()
                } else {
                    this.seller = []
                }
            },
            async fetchSellerHistory() {
                if (!this.selectedSeller || this.selectedSeller.length === 0) {
                    return
                }
                const url =
                    (JSON.parse(process.env.VUE_APP_MONITORING_PROXY_COMPANY_IDS).indexOf(
                        this.CryptoJS.AES.decrypt(localStorage.company_id, process.env.VUE_APP_ENCRYPTION_PW).toString(this.CryptoJS.enc.Utf8)
                    ) == -1
                        ? process.env.VUE_APP_MONITORING_API_URL
                        : process.env.VUE_APP_APIURL + "/monitoring-api") + "/project/get/sellers/history"
                let post_data = {
                    company_id: localStorage.company_id,
                    project_id: this.$route.params.id,
                    serp_type: "popular_products",
                    category_id: this.category_id,
                    selected_seller: this.selectedSeller
                }
                let response_data = await this.$helpers.axiosPost(url, this.withTaxonomy(post_data))
                sellerHistoryData = response_data.data
                console.log(response_data)
                this.formatSellerHistoryChartData()
            },
            async fetchFrequency() {
                try {
                    // if (this.show_ai !== true || this.isOBI) {
                    //     this.selectedType = "popular_products"
                    // }
                    let response_data = await this.fetchData()
                    console.log(response_data)
                    if (response_data.data[0].length === 0) {
                        this.selectedType = response_data.data[1][0]
                        if (this.selectedType == "ai_overview" && this.show_ai !== true) {
                            this.selectedType = response_data.data[1][1]
                        }
                        response_data = await this.fetchData()
                    }
                    this.defaultCount = response_data.data[2]
                    this.serpType = response_data.data[0][0]
                    this.formatChartData(response_data.data[0][0])
                    this.formatSellerHistoryChartData()
                    // this.formatChartData(this.testFrequencyData)
                    // all serps types in array in unique
                    this.serp_types = this.show_ai !== true ? response_data.data[1].filter((e) => e !== "ai_overview") : response_data.data[1]
                    console.log(response_data)
                } catch (error) {
                    //TODO: create notification
                    console.log(error)
                }
            },
            async fetchData() {
                const url =
                    (JSON.parse(process.env.VUE_APP_MONITORING_PROXY_COMPANY_IDS).indexOf(
                        this.CryptoJS.AES.decrypt(localStorage.company_id, process.env.VUE_APP_ENCRYPTION_PW).toString(this.CryptoJS.enc.Utf8)
                    ) == -1
                        ? process.env.VUE_APP_MONITORING_API_URL
                        : process.env.VUE_APP_APIURL + "/monitoring-api") + "/project/get/serptype"
                let post_data = {
                    company_id: localStorage.company_id,
                    project_id: this.$route.params.id,
                    serp_type: this.selectedType,
                    category_id: this.category_id
                }

                let response_data = await this.$helpers.axiosPost(url, this.withTaxonomy(post_data))
                return response_data
            },
            getValidSerpType(item) {
                return this.validSerpTypes.includes(item) ? item : false
            },
            formatChartData(data) {
                // Chart-Daten-Objekt
                this.chartData = {
                    labels: [],
                    datasets: []
                }

                // Labels für den Chart erstellen
                const dates = data.frequency.map((entry) => entry.date)
                this.chartData.labels = dates.map((date) => this.getDayMonthAndYear(date))

                // Daten für total_count und count als gestapelte Balken
                const sellerCountDataset = {
                    label: "Presence of: " + "OBI.de",
                    data: data.frequency.map((entry) => entry.seller_count), // Differenz berechnen
                    backgroundColor: "rgba(245, 155, 0, 0.62)",
                    borderColor: "#f56600",
                    borderWidth: 1,
                    maxBarThickness: 100,
                    borderRadius: {
                        topLeft: 10, // Oben links abrunden
                        topRight: 10, // Oben rechts abrunden
                        bottomLeft: 0,
                        bottomRight: 0
                    }
                }
                const totalCountDataset = {
                    label: `SERPS with ${this.selectedType.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase())} Elements`,

                    backgroundColor: "rgba(66, 165, 245, 0.62)",
                    borderColor: "#42a5f5",
                    borderWidth: 1,
                    maxBarThickness: 100,
                    borderRadius: {
                        topLeft: 10, // Oben links abrunden
                        topRight: 10, // Oben rechts abrunden
                        bottomLeft: 0,
                        bottomRight: 0
                    }
                }

                // Daten für keyword_count als Linie
                const keywordCountDataset = {
                    label: "Keyword Count",
                    data: data.frequency.map((entry) => (entry.total_count ? entry.total_count : this.defaultCount)),
                    type: "line",
                    borderColor: "#66bb6a",
                    backgroundColor: "transparent",
                    pointBackgroundColor: "rgba(255, 255, 255, 1)",
                    pointStyle: "circle",
                    pointRadius: 6,
                    pointHoverRadius: 10,
                    borderWidth: 2,
                    tension: 0
                }
                if (data.frequency[0].seller_count >= 0) {
                    totalCountDataset.data = data.frequency.map((entry) => entry.count - entry.seller_count) // Originalwert für total_count
                    this.chartData.datasets.push(sellerCountDataset)
                } else {
                    totalCountDataset.data = data.frequency.map((entry) => entry.count) // Originalwert für total_count
                }
                this.chartData.datasets.push(totalCountDataset, keywordCountDataset)
                this.renderChart++
                console.log(this.chartData)
            },
            formatSellerHistoryChartData() {
                // 1. Alle importDates sammeln und sortieren
                let historyData = sellerHistoryData
                const allDates = Array.from(new Set(historyData.map((d) => d.importDate))).sort()

                // 2. Seller gruppieren
                const sellers = Array.from(new Set(historyData.map((d) => d.seller)))

                // 3. Für jeden Seller ein Dataset bauen
                const datasets = sellers.map((seller, idx) => {
                    // Farben für die Linien (ggf. erweitern)
                    let color = "#42a5f5"
                    const isObiSeller = seller?.toLowerCase().includes("obi")
                    if (isObiSeller) color = "#f56600"
                    const colors = ["#42a5f5", "#66bb6a", "#ab47bc", "#ffa726", "#8d6e63", "#26a69a"]
                    return {
                        label: seller,
                        data: allDates.map((date) => {
                            const entry = historyData.find((d) => d.seller === seller && d.importDate === date)
                            return entry ? entry.count : 0
                        }),
                        fill: false,
                        borderColor: isObiSeller ? color : colors[idx % colors.length],
                        backgroundColor: isObiSeller ? color : colors[idx % colors.length],
                        tension: 0.1,
                        pointBackgroundColor: "rgba(255, 255, 255, 1)",
                        pointStyle: "circle",
                        pointRadius: 6,
                        pointHoverRadius: 10,
                        borderWidth: 2
                    }
                })
                // 4. Total-Count-Dataset passend zur Länge der Labels
                let totalCounts = []
                if (this.serpType && this.serpType.frequency && this.serpType.frequency.length >= allDates.length) {
                    totalCounts = this.serpType.frequency.slice(-allDates.length).map((d) => d.count)
                } else {
                    // Fallback: leeres Array oder mit 0 auffüllen
                    totalCounts = Array(allDates.length).fill(0)
                }

                const totalCountDataset = {
                    label: "SERPS with Popular Product Elements",
                    data: totalCounts,
                    fill: false,
                    borderColor: "#222",
                    backgroundColor: "#222",
                    borderDash: [5, 5],
                    pointStyle: "rectRot",
                    tension: 0.1
                }
                datasets.push(totalCountDataset)
                // 4. ChartData-Objekt bauen
                this.ppchartData = {
                    labels: allDates.map((date) => this.getDayMonthAndYear(date)),
                    datasets
                }
                this.renderChart++

                //TODO: Additional dataset for total count of elements. this.serpType.frequency.splice(this.serpType.frequency.length - datasets[0].length, )
                console.log("Hallo", this.serpType.frequency)
            },

            // Hilfsfunktion zum Generieren eines Labels
            getDayMonthAndYear(dateString) {
                const date = new Date(dateString)
                const day = date.getDate()
                const month = date.toLocaleString("default", { month: "long" })
                const year = date.getFullYear()
                return `${day} ${month} ${year}`
            }
        },
        watch: {
            // Beim Umschalten der Kategorisierung neu laden. Noetig auch dann, wenn
            // category_id unveraendert bleibt (Projektebene) und deshalb kein anderer Watcher feuert.
            taxonomyId() {
                this.fetchFrequency()
                this.fetchSellers()
            },
            show(value) {
                if (value) {
                    this.fetchFrequency()
                }
            },
            selectedSeller(val) {
                console.log("chart: ", val)
                this.fetchFrequency()
            }
        },
        mounted() {
            if (this.isOBI) {
                this.selectedType = "popular_products"
            }
            this.fetchFrequency()
            this.fetchSellers()
            this.renderChart++
        }
    }
</script>

<style lang="scss">
    #freq-chart-card {
        z-index: 3 !important;
    }
    #freq-chart-card > div.v-card__text {
        flex-grow: 1;
        min-height: 0;
        height: 100%;
        > div {
            position: relative;
            height: 280px;
        }
    }
</style>
